module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-18.671b498d.svg";